import { normalizeCnpj } from "./formats";

export function isValidCnpj(cnpj: string) {
  const normalizedCnpj = normalizeCnpj(cnpj);

  if (
    !/^[A-Z0-9]{12}\d{2}$/.test(normalizedCnpj) ||
    /^(.)\1{13}$/.test(normalizedCnpj)
  ) {
    return false;
  }

  const characterValue = (character: string) => character.charCodeAt(0) - 48;

  const calculateDigit = (base: string, weights: number[]) => {
    const total = base
      .split("")
      .reduce(
        (sum, character, index) =>
          sum + characterValue(character) * weights[index],
        0,
      );
    const remainder = total % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const firstDigit = calculateDigit(
    normalizedCnpj.slice(0, 12),
    [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2],
  );
  const secondDigit = calculateDigit(
    `${normalizedCnpj.slice(0, 12)}${firstDigit}`,
    [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2],
  );

  return (
    firstDigit === Number(normalizedCnpj[12]) &&
    secondDigit === Number(normalizedCnpj[13])
  );
}
